module.exports = __webpack_public_path__ + "static/img/bg-3.6b917b46.png";